import { useFetchDtwins } from "~/modules/dtwin/composables/useFetchDtwins";
import { useFetchUserGroups } from "~/modules/user/composables/useFetchUserGroups";
import { useFetchUsers } from "~/modules/user/composables/useFetchUsers";
import { SectorResource } from "~/types";

export function getSearchComposable(resource: SectorResource) {
  switch (resource) {
    case SectorResource.DTWINS:
      return useFetchDtwins;
    case SectorResource.USER_GROUP:
      return useFetchUserGroups;
    case SectorResource.USER:
      return useFetchUsers;
  }
}
